module.exports = __webpack_public_path__ + "static/media/PEAR.2951d3df.svg";